import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
    display: grid;
    margin: 40px 10px 100px;

    ${media.sm`
    margin: 40px 40px 100px;
    grid-template-columns: 35% 65%;
  `}

    ${media.lg`
    margin: 80px 0 160px;
    grid-template-columns: 50% 50%;
  `}
`;

export const StyledLeftPanel = styled.div`
    & > div + div {
        margin-top: 15px;
    }

    ${media.sm`
    grid-row: 1;
    margin-right: 20px;
    
    & > div + div {
      margin-top: 20px;
    }
  `}
`;

export const StyledDetailsPanel = styled.div`
    margin-top: 15px;

    & > div + div {
        margin-top: 15px;
    }

    ${media.sm`
    grid-row: 1;
    margin-top: 0;
    
    & > div + div {
      margin-top: 20px;
    }
  `}
`;

export const StyledTabsPanel = styled.div`
    margin-top: 15px;
    width: 100%;
    overflow: hidden;
    position: relative;

    ${media.sm`
    margin-top: 20px;
    grid-column: 3 / 1;
  `}
`;
